import { useCallback } from 'react';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { navs = [] } = props;
  const gotoDetail = useCallback((item: any) => {
    if (item?.redirectUrlH5) {
      window.open(item.redirectUrlH5);
    }
  }, []);
  return (
    <ul className={styles['nav-list']}>
      {navs.map((item: any) => {
        return (
          <li className={styles['inner-item']} key={item.id} onClick={() => gotoDetail(item)}>
            {item.title}
          </li>
        );
      })}
    </ul>
  );
};
